/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Status of the refund request
 */
export enum DeleteBookingResponseRefundStatus {
  succeeded = 'succeeded',
  pending = 'pending',
  failed = 'failed',
  not_eligible = 'not_eligible',
  not_applicable = 'not_applicable'
}
